import React from "react";
import WeeklySessions from "../component/WeeklySessions";

function Meetups() {
  return (
    <main><WeeklySessions id="weekly-sessions-page" /></main>
  );
}

export default Meetups;
